import { AnalyticLobCode } from 'omni-package-react-core';

export default class Constants {
  public static IDs = class {
    static iaClientSpace = 'GTM-NQLRHCR';
    static iaAdvisorCentre = 'GTM-PK73BZ6';
    static investiaClientSpace = 'GTM-WC656C6';
    static iaDealer = 'GTM-MVC6RW7';
    static iaDealerOEM = 'GTM-W3Q44XB';
    static iaPrivateWealthClientSpace = 'GTM-WRNNB6R';
    static iaPartners = 'GTM-M9HQRST';
    static iaCa = 'GTM-KDRQVT3';
  };

  public static LobCodes = class {
    static CarInsurance: AnalyticLobCode = 'ci';
    static Corporative: AnalyticLobCode = 'corpo';
    static DealerServices: AnalyticLobCode = 'ds';
    static GroupInsurance: AnalyticLobCode = 'gi';
    static GroupSavingsRetirement: AnalyticLobCode = 'gsr';
    static HomeInsurance: AnalyticLobCode = 'hi';
    static IndividualInsurance: AnalyticLobCode = 'ii';
    static IndividualSavingsRetirement: AnalyticLobCode = 'isr';
    static Loan: AnalyticLobCode = 'loan';
    static MortgageInsurance: AnalyticLobCode = 'mi';
    static Resp: AnalyticLobCode = 'resp';
    static sf: AnalyticLobCode = 'sf';
    static SicknessInsurance: AnalyticLobCode = 'si';
    static TravelInsurance: AnalyticLobCode = 'ti';
    static RecreationalVehicle: AnalyticLobCode = 'vr';
  };
}
